import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PerfilesService } from '../../../../services/perfiles/perfiles.service';

@Component({
  selector: 'app-ofertas-configuracion',
  templateUrl: './ofertas-configuracion.component.html',
  styleUrls: ['./ofertas-configuracion.component.scss']
})
export class OfertasConfiguracionComponent implements OnInit {

  constructor(
      private perfilesService: PerfilesService,
      private router: Router,
  ) { }

  ngOnInit(): void {
    this.perfilesService.allowedByUserLogon(this.router.url);
  }

}
